<script>
export default {
  methods:{
    isValidBirthdate(value){
      if (!value)
        return ''
      let minbirthdate = new Date(1900,0,1),
          maxbirthdate = new Date(2020,0,1)
      let vals = value.split('.')
      let dd = vals[0],
          mm = vals[1],
          yyyy = vals[2]
      if (!dd || dd.length != 2)
        return 'дд.мм.гггг'
      if (!mm || mm.length != 2)
        return 'дд.мм.гггг'
      if (!yyyy || yyyy.length != 4)
        return 'дд.мм.гггг'
      dd = parseInt(dd)
      mm = parseInt(mm) - 1
      yyyy = parseInt(yyyy)
      let parsed = new Date(yyyy, mm, dd)
      if (!parsed || (parsed.getDate() != dd))
        return 'Некорректная дата' 
      if (parsed > maxbirthdate || parsed < minbirthdate)
        return 'Год рождения указан неверно'
      return ''
    },
  }
}
</script>